export default __webpack_public_path__ + "static/media/stamin_loader.4ab34692.gif";